import React from "react";
import ReactDOM from "react-dom";
import "./GlassPopup.scss";

type propsType = {
  visible?: boolean;
  title?: string;
  description?: string;
  primaryText?: string;
  onPrimary?: () => void;
  secondaryText?: string;
  onSecondary?: () => void;
  onClose?: () => void;
  primaryBlue?: boolean;
  danger?: boolean;
  /** Картинка над текстом (как invisible-eye в приложении). */
  image?: string;
  /** Показывать стеклянный крестик в правом верхнем углу. */
  showClose?: boolean;
  /** Центрированный вариант (крупный serif-заголовок, иконка) — пэйвол приватных фото. */
  centered?: boolean;
};

/**
 * Стеклянный поп-ап 1:1 как в приложении (app/components/glass-popup).
 * Компактный вариант (300px, текст слева) — для «подъём применён» и подобных.
 * centered-вариант (иконка 160, serif-заголовок 34, крестик) — пэйвол приватных фото.
 */
function GlassPopup({
  visible,
  title,
  description,
  primaryText,
  onPrimary,
  secondaryText,
  onSecondary,
  onClose,
  primaryBlue,
  danger,
  image,
  showClose,
  centered,
}: propsType) {
  if (!visible) return null;

  const c = centered ? "--centered" : "";

  return ReactDOM.createPortal(
    <div className="glassPopup">
      <div className="glassPopup__backdrop" onClick={onClose} />
      <div className="glassPopup__wrap">
        <div className={`glassPopup__card${centered ? " glassPopup__card--centered" : ""}`}>
          {!!showClose && (
            <button type="button" className="glassPopup__close" onClick={onClose} aria-label="close">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1l12 12M13 1L1 13" stroke="#212121" strokeWidth="1.6" strokeLinecap="round" />
              </svg>
            </button>
          )}
          <div className={`glassPopup__content${centered ? " glassPopup__content--centered" : ""}`}>
            {!!image && (
              <div className="glassPopup__imageWrap">
                <img src={image} alt="" className="glassPopup__image" />
              </div>
            )}
            <div className={`glassPopup__textBlock${centered ? " glassPopup__textBlock--centered" : ""}`}>
              {!!title && <div className={`glassPopup__title${c}`}>{title}</div>}
              {!!description && (
                <div className={`glassPopup__description${c}`}>{description}</div>
              )}
            </div>
            {!!primaryText && (
              <button
                type="button"
                onClick={onPrimary}
                className={`glassPopup__btn ${danger ? "glassPopup__btn--danger" : primaryBlue ? "glassPopup__btn--blue" : "glassPopup__btn--primary"}`}
              >
                {primaryText}
              </button>
            )}
            {!!secondaryText && (
              <button
                type="button"
                onClick={onSecondary}
                className="glassPopup__btn glassPopup__btn--secondary"
              >
                {secondaryText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default GlassPopup;
